import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SessionService } from '../shared/services';
import { ConfigurationConstants } from '../shared/constants/config';
import { Policies } from '../shared/constants';

@Component({
  templateUrl: './start-up-menu.component.html',
  styleUrls: ['./start-up-menu.component.css']
})
export class StartUpMenuComponent implements OnInit {

  complianceCentralChoice: string;
  createDocumentationChoice: string;
  updateDocumentationChoice: string;

  updateDocumentationPolicy: string[] = [Policies.CORE_API_UPDATE_CONTROLLER_SAVED_MATCHED_DATA];

  constructor(
    private _router: Router,
    private _sessionService: SessionService,
  ) {
    this.complianceCentralChoice = ConfigurationConstants.COMPLIANCE_CENTRAL_WORKSPACE_CHOICE;
    this.createDocumentationChoice = ConfigurationConstants.CREATE_DOCUMENTATION_WORKSPACE_CHOICE;
  }

  ngOnInit(): void { }

  setWorkspaceChoice(workspaceChoice: string): void {
    this._sessionService.setWorkspaceChoice(workspaceChoice);
    this._router.navigate(['/']);
  }

  goToNewExperience(): void {
    window.location.href = '/newexperience/';
  }

}
